<transition name="modal">
  <div class="modal-mask quote-send-modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <i class="close icon" v-on:click="$emit('close')"></i>
          <h3>Send Quote</h3>
        </div>

        <div class="ui divider"></div>

        <div class="modal-body scrolling content">
          <form class="ui form">
            <div class="field">
              <app-field-label>To:</app-field-label>
              <input v-model="email.to" type="text" placeholder="e.g. email@example.com">
            </div>

            <div class="field">
              <app-field-label>Subject:</app-field-label>
              <input v-model="email.subject" type="text">
            </div>

            <div class="field">
              <app-field-label>Message:</app-field-label>
              <textarea v-model="email.message"></textarea>
            </div>
          </form>
        </div>

        <div class="modal-footer send-email-footer">
          <div class="send-email-footer__attachments-label">Attachments ({{ attachmentCards.length }}):</div>
          <div class="send-email-footer__row">
            <button
              type="button"
              class="send-email-footer__attach-btn"
              @click="onAttachClick"
            >
              <span class="send-email-footer__attach-plus" aria-hidden="true">+</span>
              Attach
            </button>
            <app-attachment-card
              v-for="card in attachmentCards"
              :key="card.id"
              :title="card.filename"
              :subtitle="card.sizeLabel"
              :thumbnail="card.thumbnail || ''"
              @remove="confirmRemoveAttachment(card)"
            ></app-attachment-card>
          </div>
          <div class="send-email-footer__actions">
            <div class="ui basic button smardie-btn-secondary" v-on:click="$emit('back')">Cancel</div>
            <div
              class="ui primary button"
              v-on:click="send"
              v-bind:class="{loading:sending, disabled:sending || !canSend}"
            >Send</div>
          </div>
        </div>

        <input
          ref="fileInput"
          type="file"
          accept="image/*,application/pdf"
          multiple
          style="position: absolute; width: 1px; height: 1px; opacity: 0; overflow: hidden; z-index: -1;"
          @change="onFilesSelected($event.target.files)"
        >
      </div>
    </div>
  </div>
</transition>
